module.exports = __webpack_public_path__ + "img/headset.6e29abb6.svg";